export default {
  name: 'BillingAccountIssue',
  data () {
    return {}
  }
}
